import { MetadataStore } from 'breeze-client';

import { Attachment } from './attachment';
import { AuditLog } from './audit-log';
import { AuthRefreshToken } from './auth-refresh-token';
import { Customer } from './customer';
import { CustomerMixStrengthLink } from './customer-mix-strength-link';
import { CustomerProductPriceOverride } from './customer-product-price-override';
import { CustomerTaxCode } from './customer-tax-code';
import { CustomerType } from './customer-type';
import { EmailMessage } from './email-message';
import { EmailMessageCustomerLink } from './email-message-customer-link';
import { EmailMessageInvoiceLink } from './email-message-invoice-link';
import { EventLog } from './event-log';
import { Invoice } from './invoice';
import { InvoiceLine } from './invoice-line';
import { InvoicePaymentMethod } from './invoice-payment-method';
import { InvoiceService } from './invoice-service';
import { InvoiceStatus } from './invoice-status';
import { InvoiceType } from './invoice-type';
import { JournalEntry } from './journal-entry';
import { Load } from './load';
import { LoadAdditive } from './load-additive';
import { LoadType } from './load-type';
import { MixStrength } from './mix-strength';
import { ParseInformation } from './parse-information';
import { Payment } from './payment';
import { PaymentCredit } from './payment-credit';
import { PaymentLine } from './payment-line';
import { PrintRequest } from './print-request';
import { PrintRequestInvoice } from './print-request-invoice';
import { Product } from './product';
import { ProductCategory } from './product-category';
import { ProductCategoryInventoryAdjustment } from './product-category-inventory-adjustment';
import { ProductCustomerTypeLink } from './product-customer-type-link';
import { ProductLocation } from './product-location';
import { ProductMaterial } from './product-material';
import { ProductUnitOfMeasure } from './product-unit-of-measure';
import { QuickBooksAccount } from './quick-books-account';
import { QuickBooksProduct } from './quick-books-product';
import { QuickBooksTask } from './quick-books-task';
import { QuickBooksTaskResponse } from './quick-books-task-response';
import { Quote } from './quote';
import { QuoteLine } from './quote-line';
import { QuoteStatus } from './quote-status';
import { Role } from './role';
import { Setting } from './setting';
import { Statement } from './statement';
import { TicketAttachment } from './ticket-attachment';
import { User } from './user';
import { UserRole } from './user-role';
import { Vendor } from './vendor';

export class BrewersRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('Attachment', Attachment);
        metadataStore.registerEntityTypeCtor('AuditLog', AuditLog);
        metadataStore.registerEntityTypeCtor('AuthRefreshToken', AuthRefreshToken);
        metadataStore.registerEntityTypeCtor('Customer', Customer);
        metadataStore.registerEntityTypeCtor('CustomerMixStrengthLink', CustomerMixStrengthLink);
        metadataStore.registerEntityTypeCtor('CustomerProductPriceOverride', CustomerProductPriceOverride);
        metadataStore.registerEntityTypeCtor('CustomerTaxCode', CustomerTaxCode);
        metadataStore.registerEntityTypeCtor('CustomerType', CustomerType);
        metadataStore.registerEntityTypeCtor('EmailMessage', EmailMessage);
        metadataStore.registerEntityTypeCtor('EmailMessageCustomerLink', EmailMessageCustomerLink);
        metadataStore.registerEntityTypeCtor('EmailMessageInvoiceLink', EmailMessageInvoiceLink);
        metadataStore.registerEntityTypeCtor('EventLog', EventLog);
        metadataStore.registerEntityTypeCtor('Invoice', Invoice);
        metadataStore.registerEntityTypeCtor('InvoiceLine', InvoiceLine);
        metadataStore.registerEntityTypeCtor('InvoicePaymentMethod', InvoicePaymentMethod);
        metadataStore.registerEntityTypeCtor('InvoiceService', InvoiceService);
        metadataStore.registerEntityTypeCtor('InvoiceStatus', InvoiceStatus);
        metadataStore.registerEntityTypeCtor('InvoiceType', InvoiceType);
        metadataStore.registerEntityTypeCtor('JournalEntry', JournalEntry);
        metadataStore.registerEntityTypeCtor('Load', Load);
        metadataStore.registerEntityTypeCtor('LoadAdditive', LoadAdditive);
        metadataStore.registerEntityTypeCtor('LoadType', LoadType);
        metadataStore.registerEntityTypeCtor('MixStrength', MixStrength);
        metadataStore.registerEntityTypeCtor('ParseInformation', ParseInformation);
        metadataStore.registerEntityTypeCtor('Payment', Payment);
        metadataStore.registerEntityTypeCtor('PaymentCredit', PaymentCredit);
        metadataStore.registerEntityTypeCtor('PaymentLine', PaymentLine);
        metadataStore.registerEntityTypeCtor('PrintRequest', PrintRequest);
        metadataStore.registerEntityTypeCtor('PrintRequestInvoice', PrintRequestInvoice);
        metadataStore.registerEntityTypeCtor('Product', Product);
        metadataStore.registerEntityTypeCtor('ProductCategory', ProductCategory);
        metadataStore.registerEntityTypeCtor('ProductCategoryInventoryAdjustment', ProductCategoryInventoryAdjustment);
        metadataStore.registerEntityTypeCtor('ProductCustomerTypeLink', ProductCustomerTypeLink);
        metadataStore.registerEntityTypeCtor('ProductLocation', ProductLocation);
        metadataStore.registerEntityTypeCtor('ProductMaterial', ProductMaterial);
        metadataStore.registerEntityTypeCtor('ProductUnitOfMeasure', ProductUnitOfMeasure);
        metadataStore.registerEntityTypeCtor('QuickBooksAccount', QuickBooksAccount);
        metadataStore.registerEntityTypeCtor('QuickBooksProduct', QuickBooksProduct);
        metadataStore.registerEntityTypeCtor('QuickBooksTask', QuickBooksTask);
        metadataStore.registerEntityTypeCtor('QuickBooksTaskResponse', QuickBooksTaskResponse);
        metadataStore.registerEntityTypeCtor('Quote', Quote);
        metadataStore.registerEntityTypeCtor('QuoteLine', QuoteLine);
        metadataStore.registerEntityTypeCtor('QuoteStatus', QuoteStatus);
        metadataStore.registerEntityTypeCtor('Role', Role);
        metadataStore.registerEntityTypeCtor('Setting', Setting);
        metadataStore.registerEntityTypeCtor('Statement', Statement);
        metadataStore.registerEntityTypeCtor('TicketAttachment', TicketAttachment);
        metadataStore.registerEntityTypeCtor('User', User);
        metadataStore.registerEntityTypeCtor('UserRole', UserRole);
        metadataStore.registerEntityTypeCtor('Vendor', Vendor);
    }
}
